import React from 'react'

import clsx from 'clsx'

import styles from './StatusDot.module.scss'
import { StatusDotColor } from './types'

export default function StatusDot({ color }: { color: StatusDotColor }) {
  return (
    <div className={clsx('StatusDot', styles.outer, styles[color])}>
      <div className={clsx(styles.inner)} />
    </div>
  )
}
